import React from 'react';

/**
 * Button - Composant bouton réutilisable avec gestion des variantes et des états.
 *
 * @param {Object} props
 * @param {string} [props.variant] - Variante visuelle ('primary', 'secondary', etc.)
 * @param {boolean} [props.disabled] - Désactive le bouton
 * @param {function} [props.onClick] - Callback au clic
 * @param {React.ReactNode} [props.children] - Contenu du bouton
 * @returns {JSX.Element}
 *
 * @example
 * <Button variant="primary" onClick={handleClick}>Valider</Button>
 */
export default function Button({ children, className = '', variant = 'primary', disabled, ...props }) {
  const base = 'flex items-center justify-center px-4 py-2 rounded-md text-sm font-heading font-normal transition focus:outline-none focus:ring-2 focus:ring-accent/40';
  const primary = 'bg-accent text-white hover:bg-accent-dark';
  const secondary = 'border border-accent text-accent bg-transparent hover:bg-accent/10';
  const disabledStyle = 'opacity-50 cursor-not-allowed';
  const style = variant === 'secondary' ? secondary : primary;
  return (
    <button
      className={`${base} ${style} ${disabled ? disabledStyle : ''} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
} 